import { Service } from "models/Service";
import { debatesFaqs } from "./faqs";

const DEBATES_FAQ_PATH = "debates/preguntas-frecuentes";

export class DebatesFaq extends Service {
  constructor() {
    super({
      adsPath: "servicios/home",
      meta: {
        description:
          "Preguntas frecuentes sobre la sección Debates de Clarín.com",
        keywords: "debates, preguntas frecuentes, clarin",
        title: "Preguntas frecuentes",
        url: DEBATES_FAQ_PATH,
        extra: [],
      },
      section: "debates",
      sectionName: "Debates",
      template: "FrequentlyAskedQuestions",
      title: "Preguntas frecuentes",
      widthFull: false,
      slug: DEBATES_FAQ_PATH,
      titleHeader: "Preguntas frecuentes",
    });

    this.setData({
      faqSections: [{ id: "debates", faqs: debatesFaqs }],
    });
  }
}
